const removeSpacesAndSpecialCharacters = (text?: string): string | undefined => {
  return text?.replace(/([^0-9a-z]|\s)/gi, "");
};

export default removeSpacesAndSpecialCharacters;
